export enum CmeProviders {
  CmeConsultants = 'cme_consultants',
  CmeOutfitters = 'cme_outfitters',
}